import { getCookie } from './components/cookie';
// import './components/signup-global-functions';
import 'jquery-validation/dist/jquery.validate';
import axios from 'axios/dist/axios';

jQuery(document).ready(($) => {
  let userIP = '';

  axios.get('https://ipapi.co/json/')
    .then(res => {
      userIP = res.data.ip ? res.data.ip : undefined;
    });

  const redirectUrl = $('.js-custom-hs-form').attr('data-redirect') ? $('.js-custom-hs-form').attr('data-redirect') : false;
  window.redirectUrl = redirectUrl;


  $('.js-custom-hs-form').on('submit', function () {
    const form = $(this);
    const redirectUrl = form.attr('data-redirect') ? form.attr('data-redirect') : false;
    const formCallback = form.attr('data-callback') ? form.attr('data-callback') : false;
    const hsListId = form.find('.js-hs-id3').val();
    const tyBox = form.siblings('.js-ty-box2');
    const hutk = getCookie('hubspotutk');
    let formValidation = $(this).valid();

    let fields = [];

    const submitBtn = form.find('button[type="submit"]');

    form.find('.field').each(function () {
      const thatInput = $(this).find('input, textarea, select');

      fields.push({
        objectTypeId: thatInput.attr('data-obj-id'),
        name: thatInput.attr('name'),
        value: thatInput.val() == null ? '' : thatInput.val(),
      });
    });

    form.find('.field-radio').each(function () {
      const thatInput = $(this).find('input');

      thatInput.each((i, e) => {
        if ($(e).is(':checked')) {
          fields.push({
            name: thatInput.attr('name'),
            value: thatInput.val(),
          });
        }
      });
    });

    form.find('.field-check').each(function () {
      const thatInput = $(this).find('input');

      thatInput.each((i, e) => {
        if ($(e).is(':checked')) {
          fields.push({
            name: thatInput.attr('name'),
            value: true,
          });
        }
      });
    });

    if (hsListId && formValidation == true) {
      submitBtn.addClass('is-loading');

      let hsObj = {
        "submittedAt": Date.now(), // This millisecond timestamp is optional. Update the value from "1517927174000" to avoid an INVALID_TIMESTAMP error.
        "fields": fields,
        "context": {
          "pageUri": window.location.href,
          "pageName": $('head title').text(),
          "ipAddress": userIP,
        },
      };

      if (hutk) {
        hsObj.context.hutk = hutk;
      }

      let additionalParams = '';

      if ($('.js-partner-form').length) {
        let partnerName = $('input[name="partner_name"]').val();
        let distributor_rep = $('input[name="victor_medical_distributor_rep"]').val();
        let company_name = $('input[name="name"]').val();
        additionalParams = `?partner_name=${partnerName}&distributor_rep=${distributor_rep}&company_name=${company_name}`;
      }

      $.ajax({
        url: `https://api.hsforms.com/submissions/v3/integration/submit/20247445/${hsListId}`,
        method: 'post',
        contentType: 'application/json',
        dataType: 'JSON',
        data: JSON.stringify(hsObj),
      })
        .done(function () {
          submitBtn.removeClass('is-loading');

          // if ($('body').hasClass('page-template-template-form')) {
          //   if (window.dataLayer) {
          //     window.dataLayer.push({
          //       'event': 'tradeshow_form_sent',
          //       'form_id': hsListId,
          //       'page_name': $('head title').text(),
          //       'user_ip': userIP,
          //       'user_agent': navigator.userAgent,
          //     });
          //   }
          // }

          if (formCallback) {
            window.redirectUrl = redirectUrl + additionalParams;
            window[formCallback]();
          } else {
            if (redirectUrl) {
              window.location = redirectUrl + additionalParams;
            } else {
              form.addClass('hidden');
              $('.content-box-form').addClass('hidden');
              tyBox.removeClass('hidden');
            }
          }
        })
        .fail(function (e) {
          console.log(e);
          submitBtn.removeClass('is-loading');

          if (e.responseJSON.errors && e.responseJSON.errors.length > 0 && e.responseJSON.errors[0].errorType === 'INVALID_IP_ADDRESS') {
            hsObj.context.ipAddress = undefined;

            $.ajax({
              url: `https://api.hsforms.com/submissions/v3/integration/submit/6240191/${hsListId}`,
              method: 'post',
              contentType: 'application/json',
              dataType: 'JSON',
              data: JSON.stringify(hsObj),
            })
              .done(function () {
                submitBtn.removeClass('is-loading');

                // if ($('body').hasClass('page-template-template-form')) {
                //   if (window.dataLayer) {
                //     window.dataLayer.push({
                //       'event': 'tradeshow_form_sent',
                //       'form_id': hsListId,
                //       'page_name': $('head title').text(),
                //       'user_agent': navigator.userAgent,
                //     });
                //   }
                // }

                if (formCallback) {
                  window.redirectUrl = redirectUrl + additionalParams;
                  window[formCallback]();
                } else {
                  if (redirectUrl) {
                    window.location = redirectUrl + additionalParams;
                  } else {
                    form.addClass('hidden');
                    $('.content-box-form').addClass('hidden');
                    tyBox.removeClass('hidden');
                  }
                }
              })
              .fail(function (resubmitError) {
                alert(JSON.stringify(resubmitError));
                console.log(resubmitError);
                submitBtn.removeClass('is-loading');
              });
          } else {
            alert(JSON.stringify(e));
          }
        });

    }

    return false;
  });
});
